import VentasLista from './VentasLista';
import {snapshotVentasLista} from '../../../utils/ventasLista';
import React, { useEffect, useMemo, useState } from 'react';
import './ListasReserva.css';
import { db } from '../../../firebase/firebaseConfig';
import { addDoc, collection, deleteDoc, doc, orderBy, query, serverTimestamp, updateDoc } from 'firebase/firestore';
import { getDocs } from '../../../utils/firestoreRead';

function normalizarTexto(s) {
  return (s || '').toString().trim().replace(/\s+/g, ' ');
}

export default function ListasReserva() {
  const [paquetes, setPaquetes] = useState([]);
  const [listas, setListas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const [open, setOpen] = useState(false);
  useEffect(()=>{if(!open)return;const previous=document.body.style.overflow;document.body.style.overflow='hidden';return()=>{document.body.style.overflow=previous;};},[open]);
 const [tab,setTab]=useState('paquetes'),[ventas,setVentas]=useState({schemaVersion:1,entradas:[],paquetes:{}});
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({
    nombre: '',
    activo: true,
    paquetes: [],
  });

  const paquetesRef = useMemo(() => collection(db, 'paquetesReserva'), []);
  const listasRef = useMemo(() => collection(db, 'listasReserva'), []);

  const cargar = async () => {
    setLoading(true);
    setError('');
    try {
      const [pSnap, lSnap] = await Promise.all([
        getDocs(query(paquetesRef, orderBy('orden', 'asc'))),
        getDocs(query(listasRef, orderBy('nombre', 'asc'))),
      ]);
      setPaquetes(pSnap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setListas(lSnap.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (e) {
      console.error(e);
      setError('No se pudieron cargar las listas/paquetes.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const abrirNuevo = () => {setTab('paquetes');setVentas({schemaVersion:1,entradas:[],paquetes:{}});
    setEditId(null);
    setForm({ nombre: '', activo: true, paquetes: [] });
    setOpen(true);
  };

  const abrirEditar = (l) => {setTab('paquetes');setVentas(l.ventasConfig||{schemaVersion:1,entradas:[],paquetes:{}});
    setEditId(l.id);
    setForm({
      nombre: l.nombre || '',
      activo: typeof l.activo === 'boolean' ? l.activo : true,
      paquetes: Array.isArray(l.paquetes) ? l.paquetes : [],
    });
    setOpen(true);
  };

  const cerrar = () => {
    setOpen(false);
    setError('');
  };

  const togglePaquete = (id) => {
    setForm((f) => {
      const s = new Set(f.paquetes || []);
      if (s.has(id)) s.delete(id);
      else s.add(id);
      return { ...f, paquetes: Array.from(s) };
    });
  };

  const guardar = async () => {
    const nombre = normalizarTexto(form.nombre);
    if (!nombre) {
      setError('Ingresa un nombre para la lista.');
      return;
    }
    if (!Array.isArray(form.paquetes) || (!form.paquetes.length&&!ventas.entradas.length)) {
      setError('Selecciona al menos 1 paquete para esta lista.');
      return;
    }

    setError('');
    try {
      const snapshot=snapshotVentasLista({...form,id:editId||'nueva',ventasConfig:ventas},paquetes);
 const payload = {ventasConfig:snapshot.config,
        nombre,
        activo: !!form.activo,
        paquetes: form.paquetes,
        updatedAt: serverTimestamp(),
      };
      if (!editId) {
        await addDoc(listasRef, { ...payload, createdAt: serverTimestamp() });
      } else {
        await updateDoc(doc(db, 'listasReserva', editId), payload);
      }
      await cargar();
      setOpen(false);
    } catch (e) {
      console.error(e);
      setError(e.message||'No se pudo guardar la lista.');
    }
  };

  const eliminar = async (l) => {
    if (!window.confirm(`¿Eliminar la lista "${l.nombre}"?`)) return;
    try {
      await deleteDoc(doc(db, 'listasReserva', l.id));
      setListas((prev) => prev.filter((x) => x.id !== l.id));
    } catch (e) {
      console.error(e);
      alert('No se pudo eliminar la lista.');
    }
  };

  const paquetePorId = useMemo(() => {
    const m = new Map();
    paquetes.forEach((p) => m.set(p.id, p));
    return m;
  }, [paquetes]);

  return (
    <div className="lr-page">
      <div className="lr-header">
        <div>
          <div className="lr-title">Listas de paquetes</div>
        </div>
        <button className="lr-primary" onClick={abrirNuevo}>+ Nueva lista</button>
      </div>

      {loading && <div className="lr-card">Cargando…</div>}
      {!loading && error && <div className="lr-error">{error}</div>}

      {!loading && !error && (
        <div className="lr-tableWrap">
          <table className="lr-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Paquetes</th>
                <th>Estado</th>
                <th style={{ width: 180 }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {listas.length === 0 ? (
                <tr>
                  <td colSpan={4} style={{ padding: 16, opacity: 0.85 }}>
                    No hay listas.
                  </td>
                </tr>
              ) : (
                listas.map((l) => (
                  <tr key={l.id}>
                    <td data-label="Nombre">
                      <div className="lr-name">{l.nombre}</div>
                      <div className="lr-id">ID: {l.id}</div>
                    </td>
                    <td data-label="Paquetes">
                      <div className="lr-badges">
                        {(l.paquetes || []).slice(0, 6).map((pid) => (
                          <span key={pid} className="lr-badge">
                            {paquetePorId.get(pid)?.nombre || pid}
                          </span>
                        ))}
                        {(l.paquetes || []).length > 6 && (
                          <span className="lr-more">+{(l.paquetes || []).length - 6} más</span>
                        )}
                      </div>
                    </td>
                    <td data-label="Estado">
                      <span className={l.activo ? 'lr-pill lr-pill--on' : 'lr-pill lr-pill--off'}>
                        {l.activo ? 'Activa' : 'Inactiva'}
                      </span>
                    </td>
                    <td data-label="Acciones">
                      <div className="lr-actions">
                        <button className="lr-btn" onClick={() => abrirEditar(l)}>Editar</button>
                        <button className="lr-btn lr-btn--danger" onClick={() => eliminar(l)}>Eliminar</button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {open && (
        <div className="lr-modalOverlay" onClick={cerrar}>
          <div className="lr-modal" role="dialog" aria-modal="true" aria-label={editId?'Editar lista':'Nueva lista'} onClick={(e) => e.stopPropagation()}>
            <div className="lr-modalHead">
              <div className="lr-modalTitle">{editId ? 'Editar lista' : 'Nueva lista'}</div>
              <button className="lr-x" aria-label="Cerrar lista" onClick={cerrar}>✕</button>
            </div>

            {error && <div className="lr-error" style={{ marginTop: 10 }}>{error}</div>}

            <nav className="lv-tabs" aria-label="Configuración de lista">{[['paquetes','Paquetes'],['entradas','Entradas'],['comisiones','Comisiones']].map(([id,label])=><button type="button" key={id} aria-pressed={tab===id} onClick={()=>setTab(id)}>{label}</button>)}</nav><div className="lr-form">{tab!=='paquetes'?<VentasLista tab={tab} config={ventas} onChange={setVentas} paquetes={paquetes} ids={form.paquetes}/>:<>
              <label>
                Nombre de la lista
                <input value={form.nombre} onChange={(e) => setForm((f) => ({ ...f, nombre: e.target.value }))} placeholder="Ej: Viernes (4 opciones)" />
              </label>

              <label className="lr-check">
                <input type="checkbox" checked={!!form.activo} onChange={(e) => setForm((f) => ({ ...f, activo: e.target.checked }))} />
                Lista activa
              </label>

              <div className="lr-box">
                <div className="lr-boxTitle">Paquetes incluidos</div>
                <div className="lr-grid">
                  {paquetes.length === 0 ? (
                    <div style={{ opacity: 0.85 }}>
                      No hay paquetes. Primero crea paquetes en “Paquetes”.
                    </div>
                  ) : (
                    paquetes.map((p) => (
                      <label key={p.id} className="lr-item">
                        <input
                          type="checkbox"
                          checked={(form.paquetes || []).includes(p.id)}
                          onChange={() => togglePaquete(p.id)}
                        />
                        <div>
                          <div className="lr-itemName">{p.nombre}</div>
                          <div className="lr-itemMeta">{Number(p.precioCentavos || 0) / 100} Bs · {(p.aplicaA || []).join(', ')}</div>
                        </div>
                      </label>
                    ))
                  )}
                </div>
              </div>
            </>} </div>

            <div className="lr-modalActions">
              <button className="lr-secondary" onClick={cerrar}>Cancelar</button>
              <button className="lr-primary" onClick={guardar}>Guardar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
